import {
  CancelableQueryViewArgs,
  query,
  Query,
  QueryHandlerFunction,
  QueryHandlerFunctionArgs,
} from "@lookiero/messaging";

const VIEW_IS_CATEGORIES_OFFFERING_ENABLED = "view_is_categories_offfering_enabled";

interface ViewIsCategoriesOfferingEnabled extends Query<typeof VIEW_IS_CATEGORIES_OFFFERING_ENABLED> {}

interface ViewIsCategoriesOfferingEnabledFunction {
  (): ViewIsCategoriesOfferingEnabled;
}

const viewIsCategoriesOfferingEnabled: ViewIsCategoriesOfferingEnabledFunction = () =>
  query({ name: VIEW_IS_CATEGORIES_OFFFERING_ENABLED });

type ViewIsCategoriesOfferingEnabledResult = boolean;

interface IsCategoriesOfferingEnabledViewArgs extends CancelableQueryViewArgs {}

interface IsCategoriesOfferingEnabledView {
  (args: IsCategoriesOfferingEnabledViewArgs): Promise<ViewIsCategoriesOfferingEnabledResult>;
}

interface ViewIsCategoriesOfferingEnabledHandlerFunctionArgs extends QueryHandlerFunctionArgs {
  readonly view: IsCategoriesOfferingEnabledView;
}

const viewIsCategoriesOfferingEnabledHandler: QueryHandlerFunction<
  ViewIsCategoriesOfferingEnabled,
  ViewIsCategoriesOfferingEnabledResult,
  ViewIsCategoriesOfferingEnabledHandlerFunctionArgs
> =
  ({ view, signal }) =>
  async () =>
    view({ signal });

export type { IsCategoriesOfferingEnabledView, ViewIsCategoriesOfferingEnabledResult };
export {
  VIEW_IS_CATEGORIES_OFFFERING_ENABLED,
  viewIsCategoriesOfferingEnabled,
  viewIsCategoriesOfferingEnabledHandler,
};
